import Vue from 'vue';
import store from '../../../src/store';
import DevRouter from '../../router';
import DevRenderer from '../../Renderer.vue';

Vue.config.productionTip = false;

class VueService {
  vue = null;

  /**
   * Init vue for dev app
   */
  initVue() {
    if (this.vue) return;

    this.initVueElementContainer();
    const elementId = 'dev-app';

    this.vue = new Vue({
      store,
      router: DevRouter,
      render: h => h(DevRenderer),
    }).$mount('#' + elementId);
  }

  initVueElementContainer() {
    const elementId = 'dev-app';
    let element = document.getElementById(elementId);
    if (element) return;

    element = document.createElement('div');
    element.id = elementId;
    document.body.appendChild(element);
  }
}

export default new VueService();
